import React, { useContext } from "react";

import AppContext from "../../../../AppContext";
import { IFlow } from "../../../Types/IFlow";
import { IStepWrapperButtonProps } from "../../Components/StepWrapper";

export interface ISchedulingStepResolver {
  isMatch: (flow: IFlow) => boolean;
  SchedulingStep: React.FC<IStepWrapperButtonProps>;
}

export interface ISwitchingSchedulingStepProps extends IStepWrapperButtonProps {
  delegateSteps: ISchedulingStepResolver[];
}

const SwitchingSchedulingStep: React.FC<ISwitchingSchedulingStepProps> = ({ delegateSteps, ...props }) => {
  const { flowCState } = useContext(AppContext);
  const match = delegateSteps.find(d => d.isMatch(flowCState));
  if (!match) throw new Error(`No scheduling step resolver matched flow: ${flowCState.name}`);
  const { SchedulingStep } = match;
  return <SchedulingStep {...props} />;
};

export default SwitchingSchedulingStep;
